<template>
  <div class="vip-banner">
    <!-- 活动 Banner -->
    <!-- <div class="reward-banner">
      <div class="gems relative" @click="goCheckIn()">
        <div class="text-12px color-#fff">
          Free gems
        </div>
        <div class="text-8px">
          Task reward
        </div>
        <div class="rili w-35px  absolute top-0px right--6px">
          <img src="@/assets/images/mine/liri.webp" alt="" class="w-full h-full">
        </div>
      </div>
      <div class="like relative" @click="goLike()">
        <div class="text-12px color-#fff">
          Like
        </div>
        <div class="text-8px">
          Favorite character
        </div>
        <div class="rili w-35px  absolute top-0px right--6px">
          <img src="@/assets/images/mine/like_banner.webp" alt="" class="w-full h-full">
        </div>
      </div>
      <div class="backpack relative" @click="goBackPack">
        <div class="text-12px color-#fff">
          Backpack
        </div>
        <div class="text-8px">
          Unlocked albums
        </div>
        <div class="rili w-35px  absolute top-0px right--6px">
          <img src="@/assets/images/mine/bag.webp" alt="" class="w-full h-full">
        </div>
      </div>
    </div> -->
    <div class="overflow-x-auto flex flex-nowrap gap-10px w-100% px-20px" v-if="![4, 5].includes(userInfo?.role)">
      <div class="vip-upgrade w-230px h-89px flex-shrink-0" @pointerdown="onPress" @click="goVip('u')">
        <img src="@/assets/images/mine/vip_u.svg" class="w-full h-full"></img>
      </div>
      <div class="vip-upgrade w-230px h-89px flex-shrink-0" @pointerdown="onPress" @click="goVip('p')">
        <img src="@/assets/images/mine/vip_p.svg" class="w-full h-full"></img>
      </div>
      <!-- <div class="vip-upgrade-vip w-230px h-89px flex-shrink-0" @pointerdown="onPress" @click="goVip('vip')">
        <img src="@/assets/images/mine/vip.svg" class="w-full h-full"></img>
      </div> -->
    </div>
    <div v-else>
      <div v-if="[5].includes(userInfo?.role)" class="vip-upgrade w-100% h-48px flex-shrink-0 relative"
        @pointerdown="onPress" @click="goVip('u')">
        <img src="@/assets/images/mine/vip_u_view.svg" class="w-full h-full"></img>
        <div class="absolute top-50% right-10% -translate-x-1/2 -translate-y-1/2 color-#FFFFFF66 text-12px font-400"
          v-if="userInfo?.subscribeExpired > 0">
          Expires on: {{ formatDate(userInfo.subscribeExpired) }}
        </div>
        <div
          class="absolute top-50% right-3% -translate-x-1/2 -translate-y-1/2  vip-upgrade-u-text flex items-center justify-center">
          View</div>
      </div>
      <!-- <div class="vip-upgrade w-100% h-48px flex-shrink-0 relative" @pointerdown="onPress" @click="goVip('vip')"
        v-if="[3].includes(userInfo?.role)">
        <img src="@/assets/images/mine/vip_vip_view.svg" class="w-full h-full"></img>
        <div
          class="absolute top-50% right-3% -translate-x-1/2 -translate-y-1/2  vip-upgrade-text flex items-center justify-center">
          View</div>
      </div> -->
      <div class="vip-upgrade w-100% h-48px flex-shrink-0 relative" @pointerdown="onPress" @click="goVip('p')"
        v-if="[4].includes(userInfo?.role)">
        <img src="@/assets/images/mine/vip_p_view.svg" class="w-full h-full"></img>
        <div class="absolute top-50% right-10% -translate-x-1/2 -translate-y-1/2 color-#FFFFFF66 text-12px font-400"
          v-if="userInfo?.subscribeExpired > 0">
          Expires on: {{ formatDate(userInfo.subscribeExpired) }}
        </div>
        <div
          class="absolute top-50% right-3% -translate-x-1/2 -translate-y-1/2  vip-upgrade-p-text flex items-center justify-center">
          View</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const userInfo = computed(() => userStore.userInfo)
import { computed } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

// 格式化时间戳为 YYYY-M-D 格式
const formatDate = (timestamp: number): string => {
  const date = new Date(timestamp * 1000)
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}
/**
 * 跳转到VIP页面
 */
const goVip = (type: string) => {
  router.push({ name: 'Vip', query: { type: type } })
}
const onPress = (e: PointerEvent) => {
}
</script>

<style scoped lang="scss">
.vip-banner {
  .vip-upgrade-text {
    // background: linear-gradient(90deg, #8699FF 0%, #5A68FF 100%);
    background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
    border-radius: 10px;
    font-weight: 800;
    font-size: 10px;
    color: #000186;
    padding: 2px 10px;
  }

  .vip-upgrade-p-text {
    // background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
    background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
    border-radius: 10px;
    font-weight: 800;
    font-size: 10px;
    color: #633302;
    padding: 2px 10px;
  }

  .vip-upgrade-u-text {
    background: linear-gradient(90deg, #EEE0FF 0%, #B27FFF 100%);
    // background: linear-gradient( 90deg, #D6DFFF 0%, #6990FF 100%);
    border-radius: 10px;
    font-weight: 800;
    font-size: 10px;
    // color: color: #2F024F;;
    color: #2F024F;
    padding: 2px 10px;
  }
}
</style>